import { CARD_TYPES, FullCardType } from 'cards/constants/CardTypes';

export const ADD_ONS_COMPATIBILITY_CAPTION: { [type in FullCardType]?: string } = {
  [CARD_TYPES.bellyBand]: 'For Classic & Petite sizes',
  [CARD_TYPES.vellumJacket]: 'For Classic size',
};

export const ADD_ONS_COMPATIBILITY_CAPTION_MWEB: { [type in FullCardType]?: string } = {
  [CARD_TYPES.bellyBand]: 'For Classic & Petite',
  [CARD_TYPES.vellumJacket]: 'For Classic',
};
